import React, {useCallback, useMemo} from 'react';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../../../src/appStyles/hooks/theme';

import {H5Text} from '../../../../../../../src/components/core/text';
import {HBox} from '../../../../../../../src/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import {Touchable} from '../../../../../../../src/components/core/touchable';
import {useGetLocale} from '@buncha/localization/hooks';

interface DeliveryFailedFooterProps {
  disabled: boolean;
  closeSheet: () => void;
  markAsFailed: () => void;
  tutorial: boolean;
}

const DeliveryFailedFooter: React.FC<DeliveryFailedFooterProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const {button} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  const getDoneCTAColor = useMemo(() => {
    if (props?.disabled) return theme?.text?.gray?.[100];
    return theme?.text?.red?.[100];
  }, [props?.disabled, theme?.text?.gray, theme?.text?.red]);

  const markOrderAsFailed = useCallback(() => {
    props?.markAsFailed();
  }, [props]);
  return (
    <HBox style={styles.buttonBox}>
      <Touchable onPress={() => props?.closeSheet()}>
        <H5Text
          style={{
            color: theme?.text?.blue?.[300],
            fontFamily: muli?.[700]?.normal,
          }}>
          {button?.cancel}
        </H5Text>
      </Touchable>
      <Touchable disabled={props?.disabled} onPress={markOrderAsFailed}>
        <H5Text
          style={{
            color: getDoneCTAColor,
            fontFamily: muli?.[700]?.normal,
          }}>
          {button?.confirmDeliveryFailed}
          <If condition={props.tutorial}>{button?.completeDelivery?.[1]}</If>
        </H5Text>
      </Touchable>
    </HBox>
  );
};

export default React.memo(DeliveryFailedFooter);

const styles = StyleSheet.create({
  buttonBox: {
    marginTop: 10,
  },
});
